// import { RawEditorSettings } from './tinymce';
import juice from 'juice';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { withLinkDialogConfig, LinkDialogConfigs } from './LinkDialogConfig';

const handleCopyImg = () => {};
const tinyStyle = 'body {margin: 0; font-size: 14px; line-height: 1.5;}';
// 需要在发信时带上的样式
// 给没有边框的表格加上边框
const defaultStyle = `
    body {line-height: 1.5; }
  a { text-decoration:none; color: #386ee7; cursor: pointer; }
  table { border-collapse: collapse; }
`;

const editorPasteConfig = {
  paste_remove_styles_if_webkit: false,
  paste_enable_default_filters: false,
  paste_data_images: true,
  // paste_preprocess: (plugin, args) => {},
};
const tableConfig = {
  table_toolbar:
    'tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
};
const contextmenu = (editor: { selection: { getContent: () => string } }) => {
  const res = editor.selection.getContent()
    ? 'cut copy paste pastetext lxcontextchangeimage | link linkchecker image imagetools spellchecker configurepermanentpen lximg | table | lxcontextOptimize'
    : 'paste pastetext | link linkchecker image imagetools spellchecker configurepermanentpen lximg | table';
  return res;
};
const lang = 'en';
const langMap = {
  en: '',
  zh: 'zh_CN',
  'zh-trad': 'zh_Trad',
};
const Arial = '思源黑体=Source Han Sans;楷体=KaiTi;宋体=simsun,serif;黑体=simhei;Arial=arial,helvetica,sans-serif;';
// 思源黑体=Source Han Sans;楷体=KaiTi;宋体=simsun,serif;黑体=simhei;Arial=arial,helvetica,sans-serif;
const fontFormats = `Calibri=Calibri;${Arial}Arial Black=arial black,avant garde;Times New Roman=times new roman,times;Verdana=verdana,geneva;Lucida Grande=lucida grande;Menlo=menlo`;
const getFullpageBodyStyle = () =>
  'line-height: 1.5; font-size: 14px; color: rgba(38, 42, 51, 0.9); font-family: arial, helvetica, sans-serif;';

// 基础编辑器配置（不包含链接对话框配置）
const baseEditorConfig = {
  ...editorPasteConfig,
  ...tableConfig,
  // clipboard,
  content_style: tinyStyle,
  contextmenu,
  juice,
  handleCopyImg,
  placeholder: '',
  defaultStyle,
  // min_height: 300,
  forced_root_block: 'div',
  font_size_legacy_values: '10px',
  fontsize_formats: '10px 11px 12px 13px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px',
  font_formats: fontFormats,
  toolbar_mode: 'sliding',
  font_css: '/pub_assets/tinymce/font.css',
  valid_children: '+head[style],+body[style],+a[#text],+blockquote[style]',
  extended_valid_elements: 'svg,path,defs,linearGradient,stop,rect',
  statusbar: false,
  nonFormat: true,
  allow_html_in_named_anchor: true,
  fullpage_body_style: getFullpageBodyStyle,
  branding: false,
  elementpath: false,
  language: langMap[lang] || '',
  autoresize_bottom_margin: 0,
  indentation: '15px',
  menubar: false,
  nonbreaking_force_tab: true,
  custom_colors: false,
  lineheight_formats: '1.0 1.5 1.75 2.0 3.0',
  table_sizing_mode: 'fixed',
  outTools: {
    debounce,
    throttle,
  },
  plugins: [
    'advlist autolink lists link lximg image print preview autoresize fullpage media table paste code lxappendvar',
    'searchreplace visualblocks fullscreen nonbreaking lxgrammar lxsignature lxsalespitch lxaiwritemail lxinputdirection',
    'lxuploadattachment lxmailformat lxcontact lxformatpainter wordcount lxemoji',
    'lxappendcommodity lxappendproduct lxsitelinkbtn lxcapturescreen lxsplitline lxbill lxappendlandingpage lxutils',
  ],
};

// 默认编辑器配置（使用自定义链接对话框）
export const editorConfig = withLinkDialogConfig(baseEditorConfig, LinkDialogConfigs.default);

// 原生编辑器配置（使用TinyMCE原生链接对话框）
export const nativeEditorConfig = withLinkDialogConfig(baseEditorConfig, LinkDialogConfigs.native);
// 签名编辑器配置（使用自定义链接对话框）
export const signatureEditorConfig = withLinkDialogConfig(baseEditorConfig, LinkDialogConfigs.signature);

